// eslint-disable-next-line no-unused-vars
export const DEFAULT_LANGUAGE = 'pt_BR';
export const FALLBACK_LANGUAGE = 'pt_BR';
export const SUPPORTED_LANGUAGES = [
  {
    code: 'en',
    language: 'English'
  },
  {
    code: 'es',
    language: 'Español'
  },
  {
    code: 'es_EC',
    language: 'Español Ecuador'
  },
  {
    code: 'pt_BR',
    language: 'Português'
  }
];
